export const DB_VERSION = 10;

export const OBJECT_STORE_SESSION = 'session';
export const OBJECT_STORE_ROM = 'rom';
export const OBJECT_STORE_MEMORY = 'memory';
export const OBJECT_STORE_STATE = 'state';
export const OBJECT_STORE_KVS = 'kvs';
export const OBJECT_STORE_MEMORY_META = 'memory-meta';
export const OBJECT_STORE_STORAGE = 'storage';
export const OBJECT_STORE_STORAGE_CARD = 'storage-card';
export const OBJECT_STORE_LOCK = 'lock';
export const OBJECT_STORE_NAND = 'nand';

export const INDEX_CARD_STORAGE_ID = 'storageId';
